import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Hero from '../../../Screens/Hero';
import {
  Content,
  HeroImage,
  Wrapper,
  Intro,
  MediaContainer,
  SubHead,
  CTAWrapper,
} from '../../../Screens/Hero/styles';

export const StyledHero = styled(Hero)`
  ${Wrapper} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      &.content-reverse {
        flex-direction: row-reverse;
      }
    }

    @media only screen and (min-width: ${themeGet(
        'breakpoints.md',
      )}) and (max-width: ${themeGet('breakpoints.lg')}) {
      &.video {
        flex-direction: column;
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      &.video {
        flex-direction: row;
      }
    }
  }

  ${Content} {
    margin: 0 auto;
    width: 100%;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 50%;
      min-height: 350px;
      margin: ${props =>
        !!props.data?.backgroundAssetPosition === true ? '0' : '0 auto'};
    }

    @media only screen and (min-width: ${themeGet(
        'breakpoints.md',
      )}) and (max-width: ${themeGet('breakpoints.lg')}) {
      &.video {
        width: 100%;
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      &.video {
        width: 50%;
      }
    }
  }

  ${Intro} {
    max-width: none;
    margin: 0.5rem 0 0;

    &.pc-points-day > p {
      font-size: 1.25rem;
      line-height: 1.5rem;
    }

    &.iol > p {
      font-size: 1.25rem;
      line-height: 150%;
      font-weight: normal;

      &:not(:last-child) {
        margin-bottom: 1rem;
      }
    }
  }
  ${SubHead} {
    max-width: none;
    h2,
    p {
      font-size: 1.25rem;
      line-height: 150%;
      color: inherit;
    }
    span {
      font-size: inherit;
      line-height: inherit;
    }
  }

  ${MediaContainer} {
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    background-image: ${props =>
      !!props.data?.backgroundAssetPosition === true
        ? `url(${props.data?.backgroundAssetDam[0].asset.localImage.publicURL})`
        : null};
    background-size: ${props =>
      props.data?.backgroundAssetDam &&
      !!props.data?.backgroundAssetPosition === true
        ? 'cover'
        : null};
    background-position: ${props =>
      !!props.data?.backgroundAssetPosition === true ? 'center' : null};
    background-repeat: ${props =>
      !!props.data?.backgroundAssetPosition === true ? 'no-repeat' : null};
    margin: ${props =>
      !!props.data?.backgroundAssetPosition === true
        ? '0 auto'
        : '2.5rem auto 0'};

    &.video {
      justify-content: center;
      margin: 1rem auto;
    }

    &.content-reverse {
      margin: 0rem auto 2.5rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 50%;
      margin: 0 auto;
      height: 100%;
      background-size: ${props =>
        props.data?.backgroundAssetDam &&
        !!props.data?.backgroundAssetPosition === true
          ? 'cover'
          : null};
      background-position: ${props =>
        !!props.data?.backgroundAssetPosition === true ? 'center' : null};
      position: ${props =>
        props.data?.backgroundAssetDam &&
        !!props.data?.backgroundAssetPosition === true
          ? 'absolute'
          : 'relative'};
      right: ${props =>
        !!props.data?.backgroundAssetPosition === true ? '0' : null};
      top: ${props =>
        !!props.data?.backgroundAssetPosition === true ? '0' : null};
    }

    @media only screen and (min-width: ${themeGet(
        'breakpoints.md',
      )}) and (max-width: ${themeGet('breakpoints.lg')}) {
      &.video {
        padding: 0rem;
        width: 100%;
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      justify-content: unset;
      background-size: ${props =>
        props.data?.backgroundAssetDam &&
        !!props.data?.backgroundAssetPosition === true
          ? 'cover'
          : null};
      &.video {
        width: 50%;
      }
    }

    &.pc-points-day {
      background-size: unset;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        background-size: ${props =>
          props.data?.backgroundAssetDam &&
          !!props.data?.backgroundAssetPosition === true
            ? 'cover'
            : null};
        background-image: unset;
      }
    }
  }

  ${HeroImage} {
    height: auto;
    margin: auto;

    @media only screen and (min-width: 414px) {
      width: 372px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 501px;
    }
  }

  ${CTAWrapper} {
    gap: 1.5rem;
    margin-top: 1rem;
    a {
      margin: 1.25rem 0;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      flex-direction: row;
      justify-content: normal;
      margin-top: 0.5rem;
    }
  }
`;
